import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { ChatPanel } from "./ChatPanel";

export function ChatWidget() {
  const [aperta, setAperta] = useState(false);

  useEffect(() => {
    const apri = () => setAperta(true);
    window.addEventListener("apri-chat", apri);
    return () => window.removeEventListener("apri-chat", apri);
  }, []);

  return (
    <>
      <button
        type="button"
        data-testid="chat-widget-toggle-btn"
        onClick={() => setAperta(!aperta)}
        aria-label={aperta ? "Chiudi chat" : "Apri chat"}
        className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-amber-500 text-obsidian shadow-[0_10px_36px_rgba(245,158,11,0.45)] transition-all hover:scale-105 hover:bg-amber-400"
      >
        {aperta ? <X size={24} /> : <MessageCircle size={24} />}
        {!aperta && (
          <span className="absolute -right-0.5 -top-0.5 flex h-3.5 w-3.5">
            <span className="absolute h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
            <span className="h-3.5 w-3.5 rounded-full border-2 border-obsidian bg-emerald-400" />
          </span>
        )}
      </button>

      {aperta && (
        <div className="glass-panel fixed bottom-[84px] right-5 z-50 h-[480px] w-[calc(100vw-40px)] max-w-sm overflow-hidden rounded-2xl">
          <ChatPanel prefisso="chat-widget" />
        </div>
      )}
    </>
  );
}
